import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { IPoint } from "Types/point";

interface IState {
  points: IPoint[];
}

const initialState: IState = {
  points: [],
};

export const pointsSlice = createSlice({
  name: "points",
  initialState,
  reducers: {
    setPoints: (state, action: PayloadAction<IPoint[]>) => {
      return { points: action.payload };
    },
    createPoint: (state, action: PayloadAction<{ point: IPoint; order?: number }>) => {
      const { point, order } = action.payload;
      const newPoint = { lat: point.lat, lng: point.lng, stationId: point.stationId };

      if (order !== undefined) {
        state.points.splice(order + 1, 0, newPoint);
      } else {
        state.points.push(newPoint);
      }
    },
    removePoint: (state, action: PayloadAction<number>) => {
      return { points: state.points.filter((point, index) => index !== action.payload) };
    },
    changePointPosition: (state, action: PayloadAction<{ point: IPoint; index: number }>) => {
      const { point, index } = action.payload;
      const newPoints = state.points.map((i, idx) => (idx === index ? { ...i, ...point } : i));

      return { points: newPoints };
    },
    clearPoints: () => {
      return { points: [] };
    },
  },
});

export const { setPoints, createPoint, removePoint, clearPoints, changePointPosition } = pointsSlice.actions;

export default pointsSlice.reducer;
